import { Pets, Vaccines } from "@mui/icons-material";
import BasePage from "../basePage";

import { useThemes } from "../../providers/theme";
import { ScheduleProvider } from "../../hooks/ScheduleContext";

import { Head } from "./Head";
import { Header } from "./Header";
import { ScheduleContent } from "./ScheduleContent";

import { Container, Schedules } from "./styles";
import { Scheduling } from "../../components/Scheduling";
import { PawPrint, Stethoscope } from "lucide-react";

export function Schedule() {
  const { theme } = useThemes();
  const Title = theme === "petland" ? <><PawPrint className="w-6 h-6" /> Banho e Tosa</> : <><Stethoscope className="w-6 h-6" />Clínica Veterinária</>
  return (
    <BasePage pageTitle={Title}>
      <Scheduling />
      <ScheduleProvider>
        <Container className={theme}>
          <Schedules>
            <Header />
            <Head />
            <ScheduleContent />
          </Schedules>
        </Container>
      </ScheduleProvider>
    </BasePage>
  );
}
